import { FC } from "react";
import { CommonIconProps } from "../Icon/types";

const Check: FC<CommonIconProps> = ({
  fill = "var(--icon-fill-color, var(--color-primary))",
  stroke = "var(--icon-stroke-color, none)"
}) => {
  return (
    <svg
      className="icon-check"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5303 5.96967C20.8232 6.26256 20.8232 6.73744 20.5303 7.03033L9.53033 18.0303C9.23744 18.3232 8.76256 18.3232 8.46967 18.0303L3.46967 13.0303C3.17678 12.7374 3.17678 12.2626 3.46967 11.9697C3.76256 11.6768 4.23744 11.6768 4.53033 11.9697L9 16.4393L19.4697 5.96967C19.7626 5.67678 20.2374 5.67678 20.5303 5.96967Z"
      />
    </svg>
  );
};

export default Check;
